import { Action, createReducer, on } from '@ngrx/store';
import {
  ILegalEntitiesProductSolutionsManageProductsRequest,
  ILegalEntitiesProductSolutionsManageProductsResponse
} from '../models/product-solutions.model';
import * as actions from '../actions';

export const leProductSolutionFeatureKey = 'leProductSolution';

export interface LeProductSolutionState {
  loadLeProductSolutionsRequest: ILegalEntitiesProductSolutionsManageProductsRequest;
  loadLeProductSolutionsResponse: ILegalEntitiesProductSolutionsManageProductsResponse[];
  loadLeProductSolutionsFailure: Error | any;
}

export const initialState: LeProductSolutionState = {
  loadLeProductSolutionsRequest: undefined,
  loadLeProductSolutionsResponse: undefined,
  loadLeProductSolutionsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadProductSolutions, (state, action) => ({
    ...state,
    loadLeProductSolutionsRequest: action.request
  })),
  on(actions.loadProductSolutionsSuccess, (state, action) => ({
    ...state,
    loadLeProductSolutionsResponse: action.response
  })),
  on(actions.loadProductSolutionsFailure, (state, action) => ({
    ...state,
    loadLeProductSolutionsFailure: action.error
  }))
);

export const getLegalEntitiesProductSolutions = (state: LeProductSolutionState) => state.loadLeProductSolutionsResponse;
